import React from "react";
import { useDispatch } from "react-redux";

import Popup from "reactjs-popup";

import { AiFillCloseCircle } from "react-icons/ai";
import { RiDeleteBinLine } from "react-icons/ri";

import t from "../../../../Common/utils/translation/translator";

import AxisComparatorSelection from "./AxisComparatorSelection";
import AxisComparatorCarriagesComparatorSelection from "./AxisComparatorCarriagesComparatorSelection";
import AxisComparatorMechanicalComparatorSelection from "./AxisComparatorMechanicalComparatorSelection";
// import AxisComparatorPerformanceComparatorSelection from "./Comparator/AxisComparatorPerformanceComparatorSelection";

import Button from "../../../../Common/components/Buttons/Button/Button";
// MSC-1778: Component ComparatorLine must be commonalized
import ComparatorLine from "../../../../Retrofit/components/Devices/BundleComparator/ComparatorLine";

const AxisComparatorCompareSection = ({
  mechanics,
  compareDatas,
  onClose,
  onSelect,
  resetAxesToCompare,
  onRemoveSolutionFromCompare
}) => {
  const dispatch = useDispatch();

  const contentStyle = {
    width: "97%"
  };

  return (
    <Popup
      data-testid="axis-comparator-compare-section-popup"
      open
      modal
      contentStyle={contentStyle}
      closeOnDocumentClick={false}
      closeOnEscape={false}
    >
      {() => (
        <div className="AxisComparatorCompareSection modal max-h-screen overflow-y-auto">
          <div>
            <div className="flex justify-end items-end">
              <AiFillCloseCircle className="text-lg text-gray-400 cursor-pointer close-modal-btn" onClick={onClose} />
            </div>
            <span className="text-gray-500 font-semibold text-base">
              <div className="md:border-[1px] md:border-solid md:border-gray-100 md:shadow-lg text-gray-600 flex flex-col space-y-5 py-4">
                <div className="mx-5 flex justify-between items-center">
                  <span className="font-bold">{t("msizer.ui.compare")}</span>
                  <Button
                    id="axis-comparator-compare-button-clear"
                    data-testid="axis-comparator-compare-button-clear"
                    textColor="blue"
                    disabled={compareDatas.length === 0}
                    onClick={() => {
                      dispatch(resetAxesToCompare());
                      onClose();
                    }}
                  >
                    <RiDeleteBinLine />
                    <span>{t("msizer.ui.compare.clear_all")}</span>
                  </Button>
                </div>

                <div className="text-xs">
                  <ComparatorLine
                    compareData={compareDatas}
                    type="header"
                    title={t("msizer.ui.compare.select_axis")}
                    headerBundles={compareDatas}
                    onSelect={onSelect}
                    onRemoveSolutionFromCompare={onRemoveSolutionFromCompare}
                  />
                  <AxisComparatorSelection
                    mechanics={mechanics}
                    compareDatas={compareDatas}
                    data-testid="axis-comparator-selection"
                  />
                  {/* <AxisComparatorPerformanceComparatorSelection
                    compareDatas={compareDatas}
                    data-testid="axis-comparator-performance-comparator-selection"
                  /> */}
                  <AxisComparatorMechanicalComparatorSelection
                    compareDatas={compareDatas}
                    data-testid="axis-comparator-mechanical-comparator-selection"
                  />
                  <AxisComparatorCarriagesComparatorSelection
                    compareDatas={compareDatas}
                    data-testid="axis-comparator-carriages-comparator-selection"
                  />
                  <ComparatorLine
                    compareData={compareDatas}
                    type="footer"
                    title={t("msizer.ui.compare.select_axis")}
                    headerBundles={compareDatas}
                    onSelect={onSelect}
                  />
                </div>
              </div>
            </span>
          </div>
        </div>
      )}
    </Popup>
  );
};

export default AxisComparatorCompareSection;
